<template>
  <div class="chat-slot h-100">
    <!-- Main Area -->
    <section class="chat-app-window h-100">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay">
        <b-spinner label="" variant="primary" class="spinner-large"></b-spinner>
      </div>

      <!-- No rom found -->
      <div v-if="chat.no_room_found" class="active-chat text-center">
        <div class="chat-navbar">
          <header class="chat-header d-flex align-items-center">
            <!-- Minimal nav: just name or title -->
            <h6 class="mb-0  d-flex align-items-center">
              <span>{{ chat.name }}</span>
            </h6>
          </header>
        </div>
        <!-- Simple text message no room -->
        <div class="mt-2">
          <p class="text-muted">{{ $t("chat.no_room_found_text") }}</p>
        </div>
      </div>

      <!-- Start Chat Logo TODO: check this part with fabian -->
      <div
        v-if="!chat.no_room_found && chat.messages.lenght"
        class="start-chat-area"
      >
        <div class="mb-1 start-chat-icon">
          <feather-icon icon="MessageSquareIcon" size="56" />
        </div>
        <h4 class="sidebar-toggle start-chat-text" @click="startConversation">
          {{ $t("chat.start_conversation") }}
        </h4>
      </div>

      <!-- Chat Content -->
      <div v-else class="active-chat">
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">
            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">
              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <div v-if="chat.roomId" class="d-flex align-items-center">
                <b-avatar
                  icon="people-fill"
                  size="35"
                  class="mr-1 cursor-pointer badge-minimal"
                  badge-variant="success"
                  variant="primary"
                  @click.native="shallShowActiveChatContactSidebar = true"
                />
                <h6 class="mb-0">
                  <span>{{ `${chat.name}` }}</span>
                </h6>
              </div>
              <div v-else class="d-flex align-items-center">
                <b-avatar
                  size="35"
                  :src="chat.image"
                  class="mr-1 cursor-pointer badge-minimal"
                  badge
                  :badge-variant="chat.online ? 'success' : 'danger'"
                  variant="primary"
                  @click.native="shallShowActiveChatContactSidebar = true"
                />

                <h6 class="mb-0">
                  <span>{{
                    `${chat.name} ${chat.first_name} ${chat.second_name}`
                  }}</span>
                </h6>
              </div>
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
              <b-button
                v-if="chat.isFromApp && (chat.chat_status_group != 'terminated') && !chatEnded"
                variant="danger"
                size="sm"
                @click="endChat"
                :disabled="loading"
                class="ml-1"
              >
              {{ $t("chat.end_chat") }}
              </b-button>

              <!--<feather-icon icon="PhoneCallIcon" size="17" class="cursor-pointer d-sm-block d-none mr-1" />
              <feather-icon icon="VideoIcon" size="17" class="cursor-pointer d-sm-block d-none mr-1" />
              <feather-icon icon="SearchIcon" size="17" class="cursor-pointer d-sm-block d-none mr-50" />
              <div class="dropdown">
                <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="17" class="align-middle text-body" />
                  </template>
                  <b-dropdown-item>
                    View Contact
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Mute Notifications
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Block Contact
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Clear Chat
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Report
                  </b-dropdown-item>
                </b-dropdown>
              </div>-->
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <vue-perfect-scrollbar
          ref="refChatLogPS"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area"
        >
          <chat-log
            :chat-data.sync="chat"
            :key="`chat-log-${chat.id}-${uuid}`"
          />
        </vue-perfect-scrollbar>

       <!-- Message Input + Buttons -->
        <!-- We disable or hide the form if chatEnded is true -->
        <div v-if="!(chat.chat_status_group == 'terminated')">
          <b-form
            class="chat-app-form"
            @submit.prevent="sendMessage"
            v-if="!chatEnded"
          >
            <b-input-group class="input-group-merge form-send-message mr-1">
              <b-form-input
                v-model="chatInputMessage"
                placeholder="Enter your message"
              />
            </b-input-group>
            <b-button variant="primary" type="submit" :disabled="buttonDisabled">
              {{ $t("chat.send") }}
            </b-button>
          </b-form>
          <div v-else class="p-2 text-center text-muted">
            {{ $t("chat.chat_has_ended") }}
          </div>
        </div>
        <div v-else class="text-center text-muted mt-2">
          <p class="text-muted">{{ $t("chat.chat_has_ended") }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import layoutMixin from "@/mixins/layoutMixin";
import { BFormInput, BFormGroup, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ChatLog from "./ChatLog.vue";
import { ref, onUnmounted, onMounted, nextTick } from "@vue/composition-api";
import axios from "@axios";
import { v4 as uuidv4 } from "uuid";
import { EventBus } from "@/libs/event-bus";

export default {
  mixins: [layoutMixin],
  components: {
    BFormInput,
    BButton,
    BFormGroup,
    VuePerfectScrollbar,
    ChatLog,
  },
  props: {
    chat: {
      type: Object,
    },
  },
  directives: {
    Ripple,
  },
  setup(props) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };

    let uuid = ref(uuidv4());
    const loading = ref(false);
    const chatEnded = ref(false);
    const buttonDisabled = ref(false);


    props.chat.messages = [];

    const chatInputMessage = ref("");

    const sendMessage = () => {
      if (!chatInputMessage.value) return;

      buttonDisabled.value = true
      let payload = {
        message: chatInputMessage.value,
      };
      
      if(props.chat.id){
        payload.user_id = props.chat.id
      }

      if (props.chat.roomId) {
        payload.group_id = props.chat.roomId;
      }

      axios.post("/v1/services/chat/chat", payload).then((response) => {
        // // Reset send message input value
        chatInputMessage.value = "";
        buttonDisabled.value = false

        // Scroll to bottom
        nextTick(() => {
          scrollToBottomInChatLog();
        });
      });
    };

    const refChatLogPS = ref(null);
    const scrollToBottomInChatLog = () => {
      const scrollEl = refChatLogPS.value.$el || refChatLogPS.value;
      scrollEl.scrollTop = scrollEl.scrollHeight;
    };

    if (props.chat.roomId) {
      EventBus.on(`new-message-${props.chat.roomId}`, (data) => {
        props.chat.messages.push(data);
        uuid.value = uuidv4();
        nextTick(() => {
          scrollToBottomInChatLog();
        });
      });
    } else {
      EventBus.on(`new-message-${props.chat.room_id}`, (data) => {
        props.chat.messages.push(data);
        uuid.value = uuidv4();
        nextTick(() => {
          scrollToBottomInChatLog();
        });
      });
    }

    const checkChatStatusAndTakeChat = async () => {
      loading.value = true;
      try {
        const { data } = await axios.get(
          `/v1/user_app_group_chat/${props.chat.id}`
        );
        const chatStatus = data.data?.status?.description || "unknown";

        if (chatStatus === "waiting") {
          console.log("Estado es waiting, ejecutando takeChat...");
          await axios.post(
            `/v1/user_app_group_chat/take-chat/${props.chat.id}`
          );
          EventBus.emit("subscribe-new-group", props.chat.roomId);
          initialSetUpGetMessages();
        } 

        if(chatStatus == 'terminated'){
          props.chat.chat_status_group = 'terminated'
          initialSetUpGetMessages();
        }
        
        else {
          initialSetUpGetMessages();
        }

      } catch (error) {
        console.error("Error al verificar estado del chat:", error);
      } finally {
        loading.value = false;
      }
    };

    const initialSetUpGetMessages = () => {
      if (props.chat.roomId) {
        axios
          .get(
            `/v1/services/chat/chat-group/getGroupMessages/${props.chat.roomId}`
          )
          .then(({ data: response }) => {
            //check if no_room_found
            if (response.data.no_room_found) {
              // set this flag in the chat object
              props.chat.no_room_found = true;
            } else {
              // normal logic
              props.chat.messages = response.data.reverse();
            }
            uuid.value = uuidv4();
            nextTick(() => {
              scrollToBottomInChatLog();
            });
          });
      } else {
        axios
          .get(`/v1/services/chat/chat/${props.chat.id}`)
          .then(({ data: response }) => {
            props.chat.messages = response.data.reverse();
            uuid.value = uuidv4();
            nextTick(() => {
              scrollToBottomInChatLog();
            });
          });
      }
    };

    const endChat = async () => {
      console.log("EndChat");
      loading.value = true;
      try {
        await axios.post(`/v1/user_app_group_chat/end-chat/${props.chat.id}`);
        chatEnded.value = true;
      } catch (error) {
        console.error("Error al terminar chat", error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      if (props.chat.isFromApp) {
        checkChatStatusAndTakeChat();
      } else {
        initialSetUpGetMessages();
      }
    });

    onUnmounted(() => {
      EventBus.off(`new-message-${props.chat.room_id}`);
    });

    return {
      perfectScrollbarSettings,
      sendMessage,
      chatInputMessage,
      uuid,
      refChatLogPS,
      endChat,
      loading,
      chatEnded,
      buttonDisabled,
    };
  },
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spinner-large {
  width: 3rem;
  height: 3rem;
}
</style>
